<div class="mobile-warning" [ngClass]="{'off': !mobile, 'animate': animateOut}">
    <div class="basic-modal">
        <img src="../../../assets/images/logo.svg" alt="Bayer" class="logo">
        <p>{{message}}</p>
    </div>
</div>